
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

interface StateOption {
  label: string;
  value: string;
}

@Component({
  selector: 'app-account-personal-info-form',
  providers: [provideNgxMask()],
  imports: [
    ReactiveFormsModule,
    MatCardModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
    SharedModule,
    NgxMaskDirective
],
  templateUrl: './account-personal-info-form.component.html',
  styleUrl: './account-personal-info-form.component.scss'
})
export class AccountPersonalInfoFormComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input() sectionTitle = 'Personal Information';
  @Input() showChangePasswordButton = true;
  @Input() dashboardRoute: string | null = null;
  @Input() showJobTitleField = false;
  @Input() showFaxNumberField = false;
  @Input() showAddressFields = false;
  @Input() stateOptions: StateOption[] = [];
  @Input() phoneMask: string | null = null;
  @Input() phoneValidationErrorKey: 'mask' | 'pattern' = 'pattern';
  @Input() phoneValidationErrorText = 'Please enter a 10-digit phone number.';
  @Output() saveRequested = new EventEmitter<void>();
  @Output() cancelRequested = new EventEmitter<void>();
  @Output() changePasswordRequested = new EventEmitter<void>();

  onSaveRequested(): void {
    this.saveRequested.emit();
  }

  onCancelRequested(): void {
    this.cancelRequested.emit();
  }

  onChangePasswordRequested(): void {
    this.changePasswordRequested.emit();
  }
}
